import React, { useContext } from 'react';
import {
  EditSceneModalPlaybackContextType,
  EditSceneModalPlaybackProviderProps,
} from './types';

const EditSceneModalPlaybackContext = React.createContext<
  EditSceneModalPlaybackContextType | undefined
>(undefined);

export const EditSceneModalPlaybackProvider: React.FC<EditSceneModalPlaybackProviderProps> = ({
  children,
  playerRef,
}) => (
  <EditSceneModalPlaybackContext.Provider value={{ playerRef }}>
    {children}
  </EditSceneModalPlaybackContext.Provider>
);

export function useEditSceneModalPlaybackContext() {
  const context = useContext(EditSceneModalPlaybackContext);

  if (context === undefined) {
    throw new Error(
      'useEditSceneModalPlaybackContext must be used within a EditSceneModalPlaybackProvider',
    );
  }

  return context;
}
